import { siteContent } from "../../content/siteContent";

export function Philosophy() {
  const { philosophy } = siteContent;

  return (
    <section className="home-philosophy home-section" aria-labelledby="home-philosophy-title">
      <div className="home-shell">
        <p className="home-eyebrow">{philosophy.eyebrow}</p>
        <div className="home-philosophy__layout">
          <h2 id="home-philosophy-title" className="home-philosophy__title">
            {philosophy.titleLines.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </h2>
        </div>
      </div>
    </section>
  );
}
